export const MODAL_TITLE = 'Installment (Normal Loan)';
